import React, { useState } from "react";
import "../Aboutus/Aboutme.css";

const AboutMe = () => {
  const [isVideoOpen, setVideoOpen] = useState(false);

  const toggleVideo = () => {
    setVideoOpen(!isVideoOpen);
  };

  return (
    <section className="about-us-m">
      <h1 className="heading-m">
        About <span className="heading-m-span">Us</span>
      </h1>
      <hr className="red-line-m" />
      <div className="content-m">
        {/* Left Div */}
        <div className="left-div-m">
          <p className="description-m">HOW WE ARE</p>
          <h1 className="subheading-m">
            We design unique spaces your home should be one.
          </h1>
          <div className="image-wrapper-m">
            <img src="me1.webp" alt="About" className="image-m" />
            <div className="play-button-m" onClick={toggleVideo}>
              ▶
            </div>
          </div>
        </div>

        {/* Right Div */}
        <div className="right-div-m">
          <img src="me2.webp" alt="About" className="image-right-m" />
          <p className="additional-text-m">
            The global minerals laboratory network services clients wherever
            they are based with mineral assay laboratories located in key mine
            regions and location testing services.
          </p>
        </div>
      </div>

      {/* Video Overlay */}
      {isVideoOpen && (
        <div className="video-overlay-m">
          <div className="video-content-m">
            <span className="close-button-m" onClick={toggleVideo}>
              ✖
            </span>
            <video className="video-sec" controls>
              <source src="video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutMe;
